class OrderedList2 {

	constructor(container) {
		this._index = 0;
		this._items = [];
		this._ids = [];
		this._shifting = false;

		this._container = container || div();
		this._dragProperty = null;
		this._rowProperty = null;
		this._orderProperty = null;
		this._useIds;

		this._activeRow = null;
		this._callback = null;
	}

	get container() { return this._container; }

	addItem(item, orderBy, rowElem, dragElem) {
		let i = this._items.length;
		if (i === 0) {
			// first item being added, store properties for later use
			this._useIds = typeof item.id !== 'undefined';
			if (orderBy) this._orderProperty = orderBy.name;
			if (rowElem) this._rowProperty = rowElem.name;
			if (dragElem) this._dragProperty = dragElem.name;
		}
		if (orderBy) {
			while (0 < i && item[this._orderProperty]() < this._items[i-1][this._orderProperty]()) i--;
		}
		if (rowElem) {
			this._container.insertBefore(
				item[this._rowProperty](),
				i < this._items.length ? this._items[i][this._rowProperty]() : null
			);
		}
		if (this._useIds) this._ids.splice(i, 0, item.id);
		this._items.splice(i, 0, item);
	}

	reset() {
		this._index = -1;
		return this._items.length > 0;
	}

	seek(i) {
		if (i < 0 || i >= this._items.length) return false;
		this._index = i;
		return this._items[i];
	}

	getPos() {
		return this._index + 1;
	}

	moveFirst() {
		if (this._items.length) {
			this._index = 0;
			return true;
		}
		return false;
	}

	moveNext() {
		if (this._index + 1 < this._items.length) {
			this._index++;
			return true;
		}
		return false;
	}

	getIndex(item) {
		if (typeof (item) === 'object') {
			return this._items.indexOf(item);
		} else {
			return -1;
		}
	}

	getItemById(id) {
		let i = this._useIds ? this._ids.indexOf(id) : -1;
		if (i === -1) return false;
		return this._items[i];
	}

	getItem() {
		if (this._items.length && this._index < this._items.length) return this._items[this._index];
		return false;
	}

	getPrev() {
		if (this._index === 0) return false;
		return this._items[this._index - 1];
	}

	getNext() {
		if (this._index === this._items.length - 1) return false;
		return this._items[this._index + 1];
	}

	removeItemByIndex(i) {
		i = (typeof (i) === 'number') ? i : this._items.length - 1;
		if (this._container) this._container.removeChild(this._items[i][this._rowProperty]());
		if (this._useIds) this._ids.splice(i, 1);
		return this._items.splice(i, 1)[0];
	}

	removeItemById(id) {
		let i = this._useIds ? this._ids.indexOf(id) : -1;
		if (i === -1) return false;
		return this.removeItemByIndex(i);
	}

	removeItem(obj) {
		let i = this._items.indexOf(obj);
		if (i === -1) return false;
		return this.removeItemByIndex(i);
	}

	clear() {
		this._index = 0;
		this._items = [];
		this._ids = [];
		this._shifting = false;
	}

	get length() {
		return this._items.length;
	}

	prepDrag(row, ev) {
		if (this._dragProperty === null || this._rowProperty === null) return;
		state(row[this._dragProperty](), 'drag');
		this._activeRow = row;
		this._index = this._items.indexOf(row);
		if (this._index === -1) return;
		startDrag(ev, this);
		this.curInElem = pointInElem(row[this._rowProperty]());
		row[this._rowProperty]().style.height = row[this._dragProperty]().offsetHeight + 'px';
		row[this._dragProperty]().style.width = row[this._rowProperty]().offsetWidth + 'px';
		document.body.appendChild(row[this._dragProperty]());
		this.positionDragElem();
	}

	drag() {
		// x,y are the coordinate from the event
		// return new position in the list
		if (this._shifting) return;
		var i = this._items.indexOf(this._activeRow);
		var pnt = pointInElem(this._activeRow[this._rowProperty]());
		if (pnt.y < 0 && 0 < this._index) {
			this.moveUp();
		} else if (this._activeRow[this._rowProperty]().offsetHeight < pnt.y && this._index < (this._items.length)) {
			this.moveDn();
		}
		this.positionDragElem();
	}

	positionDragElem() {
		this._activeRow[this._dragProperty]().style.left = pointB.x - this.curInElem.x + 'px';
		this._activeRow[this._dragProperty]().style.top = pointB.y - this.curInElem.y + 'px';
	}

	reattach() {
		state(this._activeRow[this._dragProperty](), 'norm');
		this._activeRow[this._rowProperty]().appendChild(this._activeRow[this._dragProperty]());
		this._activeRow[this._rowProperty]().style.height = 'auto';
		this._activeRow[this._dragProperty]().style.left = '0px';
		this._activeRow[this._dragProperty]().style.top = '0px';
		this._activeRow[this._dragProperty]().style.width = '100%';
	}

	clicked(ev) {
		this.reattach();
		if (this._activeRow.clicked) this._activeRow.clicked(ev);
	}

	dropped(ev) {
		this.reattach();
		this.reOrder();
		if (this._activeRow.dropped) this._activeRow.dropped(ev);
	}

	moveUp() {
		if (this._index <= 0) return;
		this._shifting = 1;
		this._container.insertBefore(
			this._container.removeChild(this._items[this._index][this._rowProperty]().previousSibling),
			this._items[this._index][this._rowProperty]().nextSibling
		);

		if (this._useIds) this._ids.splice(this._index-1, 0, this._ids.splice(this._index, 1)[0]);
		this._items.splice(this._index-1, 0, this._items.splice(this._index, 1)[0]);
		this._index--;
		this._shifting = 0;
	}

	moveDn() {
		if (this._items.length-1 <= this._index) return;
		this._shifting = 1;
		this._container.insertBefore(
			this._container.removeChild(this._items[this._index][this._rowProperty]().nextSibling),
			this._items[this._index][this._rowProperty]()
		);

		if (this._useIds) this._ids.splice(this._index+1, 0, this._ids.splice(this._index, 1)[0]);
		this._items.splice(this._index+1, 0, this._items.splice(this._index, 1)[0]);
		this._index++;
		this._shifting = 0;
	}

	reOrder() {
		for (var i = 0; i < this._items.length; i++) {
			this._items[i].orderBy = i + 1;
		}
	}

	sort() {
		if (this.moveFirst()) do {
			while (this.getItem().orderBy < this.getPos()) {
				this.moveUp();
			}
		} while (this.moveNext());
	}

	showSaving() {
		state(this._container, 'loading');
	}

	hideSaving() {
		state(this._container, 'norm');
	}
}